import { httpClient } from '#shared'
import type { GetChatResponse } from '../model/get-chat-response'

export async function getChat(chatId: number) {
  const response = await httpClient.get<GetChatResponse>(`chats/${chatId}`, { requireAuth: true })
  const responseBody = await response.json()

  return responseBody
}
